var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Profits.Title")))
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("Expanded.BudgetaryEstimate.Profits.ProposedAid"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Profits.AddNew")))]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(_vm.$t("BudgetaryEstimate.Profits.AddNew_Instructions"))
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Profits.GrantorsAndPurposes")))
    ]),
    _vm._v(" "),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("BudgetaryEstimate.Profits.GrantorsAndPurposes_Instructions")
        )
      }
    }),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Expenses")))]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.PersonnelExpenses.HasPersonnel")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.PersonnelExpenses.HasPersonnel_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("BudgetaryEstimate.PersonnelExpenses.SalaryItems.Title"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.PersonnelExpenses.SalaryItems.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("BudgetaryEstimate.PersonnelExpenses.SalaryItems.JobTitle")
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.JobTitle_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.Description"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.GrossSalary"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.GrossSalary_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.WorkingHours"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.WorkingHours_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.WorkingHoursPercent"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.WorkingHoursPercent_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.IsDivided"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BudgetaryEstimate.PersonnelExpenses.SalaryItems.IsDivided_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Title"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Rewards_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.HourlyWages_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Pensions_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.StatutoryPersonnelCosts_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.VoluntaryStaffCosts_Details"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Premises.PremiseTypes.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("BudgetaryEstimate.Premises.PremiseTypes.Title_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Premises.OwnPremises.Title")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("BudgetaryEstimate.Premises.OwnPremises.Title_Instructions")
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("BudgetaryEstimate.Premises.RelatedPremises.Title"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.Premises.RelatedPremises.Title_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("BudgetaryEstimate.Premises.RentalPremises.Title"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.Premises.RentalPremises.Title_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Premises.OtherPremises")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("BudgetaryEstimate.Premises.OtherPremises_Instructions")
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.OtherExpenses.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(_vm.$t("BudgetaryEstimate.OtherExpenses.Title_Instructions"))
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.OperationalExpenses.Breakdown")))
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("BudgetaryEstimate.OperationalExpenses.Other")) +
            "\n      "
        ),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t("BudgetaryEstimate.OperationalExpenses.Other_Instructions")
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    !_vm.isAy && !_vm.isPlaceOpen
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.GeneralExpenses.Title")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BudgetaryEstimate.GeneralExpenses.Title_Instructions")
              )
            )
          ]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Delegation.Title")))
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(
              _vm._s(_vm.$t("BudgetaryEstimate.Delegation.IsAidDelegated"))
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "BudgetaryEstimate.Delegation.IsAidDelegated_Instructions"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Delegation.TargetAmount")))
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Delegation.SumMinMax")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BudgetaryEstimate.Delegation.SumMinMax_Instructions")
              )
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Delegation.Member")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("BudgetaryEstimate.Delegation.Member_Instructions"))
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Delegation.Partner")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BudgetaryEstimate.Delegation.Partner_Instructions")
              )
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("h3", { staticClass: "mt-0" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Total.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Total.Title_Instructions")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.MoreInformation")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("Expanded.BudgetaryEstimate.ChangesToBudgetaryEstimate"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }